import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface StyledBottomSheetProps {
    open?: boolean;
}

const StyledBottomSheet = styled(Box, {
    shouldForwardProp: (prop) => prop !== "open",
})<StyledBottomSheetProps>(({ theme, open }) => ({
    position: "fixed",
    width: "100vw",
    height: (theme as any).footer?.height || "60px",
    zIndex: 100,
    background: theme.palette.background.paper,
    bottom: 0,
    left: 0,
    transform: `translateY(${(theme as any).footer?.height || "60px"})`,
    willChange: "transform",
    transition: "transform .3s ease-out",
    color: theme.palette.grey[700],
    ...(open && {
        transform: "translateY(0)",
    }),
}));

interface BottomSheetProps {
    children?: React.ReactNode;
    open?: boolean;
}

export const BottomSheet = (props: BottomSheetProps) => {
    const { children, open } = props;
    return (
        <StyledBottomSheet open={open} data-testid="bottom-sheet">
            {children}
        </StyledBottomSheet>
    );
};
